var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInProgressVoip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.614 3.586c.542.748.748 1.748.578 2.815l-.824 5.17c-.343 2.146-1.954 3.369-4.008 3.044l-5.485-.874-.014-.002c-1.015-.165-1.823-.655-2.336-1.418-.5-.746-.677-1.687-.512-2.722l.004-.025a.198.198 0 0 1 .195-.167H4.12a.494.494 0 1 0 0-.989H2.201l.23-1.439c.018-.114.147-.177.262-.177H4.88a.494.494 0 0 0 0-.988H2.693a.499.499 0 0 0-.077.006l.221-1.39.017-.098a.192.192 0 0 1 .19-.157h1.163a.494.494 0 0 0 0-.99h-.984c.666-1.354 2.006-2.055 3.621-1.8h.001l.22.035a.198.198 0 0 1 .165.227l-.82 5.104a.496.496 0 0 0 .566.567l1.792-.287 1.602.823a.495.495 0 0 0 .714-.362l.816-5.1a.198.198 0 0 1 .226-.165l.204.033.014.002c.97.157 1.755.615 2.27 1.324z",
    fill: "#004CC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.77 6.03-1.278.203.712-4.43a.198.198 0 0 1 .226-.165l2.327.37a.198.198 0 0 1 .164.227l-.708 4.428-1.14-.585a.491.491 0 0 0-.303-.049zM1.862 2.526a.494.494 0 1 0 0 .99H4.05a.494.494 0 0 0 0-.99H1.862zM2.541 5.154a.494.494 0 1 0 0 .99H4.73a.494.494 0 0 0 0-.99H2.54zM1.78 7.759a.494.494 0 0 0 0 .989h2.188a.494.494 0 0 0 0-.99H1.78z",
    fill: "#004CC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInProgressVoip);
export default __webpack_public_path__ + "static/media/ic-in-progress-voip.a747209771a36a28482490d40a82f997.svg";
export { ForwardRef as ReactComponent };